import { useTranslation } from 'react-i18next'
import { CategoryItem } from './item'
import c from './assets/sass/categories.module.scss'

const CATEGORY_KEYS = ['tapper', 'referrals', 'tasks', 'shop', 'modes', 'leaderboard']

export const Categories = ({ onSelect }) => {
    const { t } = useTranslation()

    return (
        <div className={c.component}>
            {CATEGORY_KEYS.map((key) => (
                <CategoryItem
                    key={key}
                    title={t(`faq.categories.${key}.title`)}
                    description={t(`faq.categories.${key}.description`)}
                    onClick={() => onSelect(key)}
                />
            ))}
        </div>
    )
}
